import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, useRef, useState, forwardRef } from 'react';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { RuleTypeDropdown } from './rule_type_dropdown';
import { SearchInput } from './search_input';
import { SearchResults } from './search_results';
const containerCss = "c1gg5avq";
const Container = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const labelCss = "l1u7yjlh";
const Label = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(labelCss, props.className)} />);
export const RuleField = ({
  rule,
  onSubmit,
  onClose,
  showSearchStatus,
  doubleBookingSuggestions,
  doubleBookingSearching,
  doubleBookingSearchError
}) => {
  const containerRef = useRef();
  const [type, setType] = useState(rule.type);
  const [searchTerm, setSearchTerm] = useState(rule.searchTerm);
  const handleSubmit = useCallback(() => {
    onSubmit({
      id: rule.id,
      type,
      searchTerm
    });
  }, [onSubmit, rule.id, type, searchTerm]);
  useOnClickOutside(containerRef, handleSubmit);
  return <Container ref={containerRef}>
      <Label>
        <BodyText size="medium" weight="bold">
          {I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.add_meeting_exception.input_label')}
        </BodyText>
        <RuleTypeDropdown value={type} onChange={setType} />
      </Label>
      <SearchInput value={searchTerm} onChange={setSearchTerm} onSubmit={handleSubmit} onClose={onClose} />
      {showSearchStatus && <SearchResults type={type} searchTerm={searchTerm} suggestions={doubleBookingSuggestions} isSearching={doubleBookingSearching} hasSearchError={doubleBookingSearchError} />}
    </Container>;
};

require("./rule_field.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./rule_field.js");